import React from 'react';
import styles from './AssetInventoryActions.module.scss';
import { useSelector } from 'react-redux';

import { ForgeButton } from '@tylertech/forge-react';
import Form from 'common/components/Forms/Form';
import { I18n } from 'common/i18n';
import { selectButtonDisabled, selectShowScheduleJobButton } from '../selectors/asset-inventory-view-model';

export const AssetInventoryActions = () => {
  /**
   *   showAssetInventoryDatasetButton is true for anyone who has access to the asset inventory dataset.
   */
  const showAssetInventoryDatasetButton = !useSelector(selectButtonDisabled);
  const showScheduleJobButton = useSelector(selectShowScheduleJobButton);
  const scope = 'shared.asset_browser.asset_inventory_actions';

  return (
    <div className={styles.assetInventoryActions}>
      {showScheduleJobButton && (
        <Form key="schedule" action="/admin/asset_inventory/schedule">
          <ForgeButton data-testid="schedule-asset-inventory-job" variant="outlined" type="submit">
            {I18n.t('update_asset_inventory', { scope })}
          </ForgeButton>
        </Form>
      )}
      {showAssetInventoryDatasetButton && (
        <a key="show" href="/admin/asset_inventory">
          <ForgeButton data-testid="view-asset-inventory-dataset" variant="outlined">
            {I18n.t('asset_inventory_dataset', { scope })}
          </ForgeButton>
        </a>
      )}
    </div>
  );
};
